import React, { useState, useEffect } from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import doctorImg from "../../assets/images/doctor.png";
import DoctorCard from "../../components/DoctorCard";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Grid, Autoplay } from "swiper/modules";
import { fetchAPI } from "../../utils/api";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/grid";

const fallbackDoctors = [
  {
    doctor_id: 1,
    doctor_name: "Dr. Poonam Rawat",
    speciality: "Brain, Spine Specialist",
    image: doctorImg,
    experience: "8 Yrs",
    rating: "4.9",
  },
  {
    doctor_id: 2,
    doctor_name: "Dr. Sonam Agarwal",
    speciality: "Cardiologists & Gynecologist",
    image: doctorImg,
    experience: "8 Yrs",
    rating: "4.9",
  },
];

export default function Specialties({ homeSettings = {} }) {
  const [doctorsList, setDoctorsList] = useState([]);
  const [loading, setLoading] = useState(true);

  const title =
    homeSettings.home_doc_title && homeSettings.home_doc_title.trim() !== ""
      ? homeSettings.home_doc_title
      : "Doctor Consultant";
  const description =
    homeSettings.home_doc_description &&
    homeSettings.home_doc_description.trim() !== ""
      ? homeSettings.home_doc_description
      : "Compassionate nursing care, physiotherapy, and bedside assistance tailored for patient comfort, recovery, and daily healthcare support.";
  const link =
    homeSettings.home_doc_link && homeSettings.home_doc_link.trim() !== ""
      ? homeSettings.home_doc_link
      : "/doctor-consultation-services";

  useEffect(() => {
    const loadDoctors = async () => {
      try {
        setLoading(true);
        const res = await fetchAPI("DoctorController/doctors", {
          method: "POST",
          body: JSON.stringify({}),
        });
        if (
          res &&
          res.status === 200 &&
          Array.isArray(res.result) &&
          res.result.length > 0
        ) {
          setDoctorsList(res.result);
        } else {
          setDoctorsList(fallbackDoctors);
        }
      } catch (err) {
        console.error("Error loading doctors for home Specialties:", err);
        setDoctorsList(fallbackDoctors);
      } finally {
        setLoading(false);
      }
    };

    loadDoctors();
  }, []);

  const displayDoctors = doctorsList.length > 0 ? doctorsList : fallbackDoctors;

  return (
    <div className="specialties_section">
      <div className="container-fluid">
        <div className="section_heading row align-items-center">
          <div className="content_part col-lg-6 col-sm-8 col-6">
            <h3>{title}</h3>
            <p>{description}</p>
          </div>
          <div className="btn_part col-lg-6 col-sm-4 col-6 text-end">
            <button className="main_btn">
              <Link to={link}>
                View All <ArrowForwardIosIcon />
              </Link>
            </button>
          </div>
        </div>

        {loading ? (
          <div className="text-center py-4 text-muted">Loading doctors...</div>
        ) : (
          <Swiper
            key={displayDoctors.length}
            modules={[Navigation, Grid, Autoplay]}
            navigation
            spaceBetween={16}
            slidesPerView={3}
            speed={500}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            grid={{
              rows: displayDoctors.length > 3 ? 2 : 1,
              fill: "row",
            }}
            breakpoints={{
              320: {
                slidesPerView: 1,
                grid: {
                  rows: 1,
                },
              },
              768: {
                slidesPerView: 2,
                grid: {
                  rows: displayDoctors.length > 2 ? 2 : 1,
                },
              },
              1200: {
                slidesPerView: 3,
                grid: {
                  rows: displayDoctors.length > 3 ? 2 : 1,
                },
              },
            }}
          >
            {displayDoctors.map((doctor, idx) => (
              <SwiperSlide key={doctor.doctor_id || doctor.id || idx}>
                <DoctorCard doctor={doctor} />
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </div>
  );
}
